import React from 'react';
import PropTypes from 'prop-types';

import { SUPER_TECHNICIAN, SUPER_RESEARCHER } from 'constants/userRoles';

import PaperWithLoader from 'components/ui/PaperWithLoader';
import ReportsList from './ReportsList';

class ReportsListIndex extends React.Component {
  static propTypes = {
    patientsData: PropTypes.shape({}).isRequired,
    requestPatientsInfo: PropTypes.func.isRequired,
    isData: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    role: PropTypes.string.isRequired,
    userId: PropTypes.string.isRequired,
  };

  componentDidMount() {
    const { role, loading, isData, requestPatientsInfo, userId } = this.props;

    if (!loading && !isData) {
      const generalPracitioner =
        role === SUPER_RESEARCHER || role === SUPER_TECHNICIAN ? null : userId;
      requestPatientsInfo({ elements: 'communication,name', generalPracitioner });
    }
  }

  render() {
    const { userId, loading, isData, role, patientsData } = this.props;
    return (
      <PaperWithLoader loading={loading || !isData}>
        <ReportsList userId={userId} patientsData={patientsData} role={role} />
      </PaperWithLoader>
    );
  }
}

export default ReportsListIndex;
